import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import useProductName from "brand-customization/useProductName";
import { FormikFormGroup } from "components/common";
const FIELD_PREFIX = "snapshot_archiving_config";
const SnapshotFSPathFieldGroup = () => {
  const { setFieldValue } = useFormikContext();
  const productName = useProductName();
  useEffect(
    () => () => {
      setFieldValue(`${FIELD_PREFIX}.path`, void 0);
    },
    [setFieldValue]
  );
  return /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: `${FIELD_PREFIX}.path`,
      type: "text",
      label: "Path Override (optional)",
      help: `Optional read-path override. When empty, the repository's registered location is used. Must be readable by every ${productName} node that may archive.`,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  );
};
export default SnapshotFSPathFieldGroup;
